import SortArrows from '../../components/icons/sort-arrows.jsx';
import { setSorting, setCheckedItems } from '../../store/organizersSlice';

export const getHeaders = (
    sortBy,
    sortDirection,
    dispatch,
    sortArrowColorActive,
    sortArrowColorInactive,
    rowsData,
    checkedItems
) => {
    const allIds = rowsData.map((row) => row.id);
    const allChecked = rowsData.length > 0 && checkedItems.length > 0 && allIds.every((id) => checkedItems.includes(id));

    return [
        <label
            key="header-checkbox-label"
            className="checkbox-wrapper"
            onClick={(e) => e.stopPropagation()}
        >
            <input
                id="header-checkbox-all"
                name="header-checkbox-all"
                type="checkbox"
                checked={allChecked}
                onChange={(e) => {
                    if (e.target.checked) {
                        dispatch(setCheckedItems([...new Set([...checkedItems, ...allIds])]));
                    } else {
                        dispatch(setCheckedItems(checkedItems.filter((id) => !allIds.includes(id))));
                    }
                }}
            />
        </label>,
        <div key="actions-header">Akcje</div>,
        <div key="date-header" className="table-columns-headers">
            <div>Data rejestracji</div>
            <SortArrows
                upColor={sortBy === 'registration_date' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'registration_date' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('registration_date', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="company-header" className="table-columns-headers">
            <div>Nazwa firmy</div>
            <SortArrows
                upColor={sortBy === 'company_name' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'company_name' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('company_name', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="nip-header">NIP</div>,
        <div key="address-header">Adres</div>,
        <div key="contact-header">Kontakt</div>,
        <div key="status-header">Status</div>,
    ];
};

const handleSort = (columnName, sortBy, sortDirection, dispatch) => {
    if (sortBy !== columnName) {
        dispatch(setSorting({ sortBy: columnName, sortDirection: 'ASC' }));
        return;
    }

    if (sortDirection === 'ASC') {
        dispatch(setSorting({ sortBy: columnName, sortDirection: 'DESC' }));
        return;
    }

    dispatch(setSorting({ sortBy: null, sortDirection: null }));
};

// Checkbox | Akcje | Data rejestracji | Nazwa firmy | NIP | Adres | Kontakt | Status
export const headerWidths = ['42px', '60px', '172px', '1fr', '160px', '1fr', '1fr', '140px'];

export const deleteSelected = (selectedIds, dispatch) => {
    console.log('Delete selected organizers:', selectedIds);
    if (selectedIds.length === 0) {
        alert('Nie wybrano żadnych organizatorów do usunięcia');
        return;
    }
    if (window.confirm(`Czy na pewno chcesz usunąć ${selectedIds.length} organizatorów?`)) {
        alert('Funkcja usuwania w trakcie implementacji');
    }
};
